import { Brand, Domains } from "@/core/types/types";

const getBrandName = (host: string): Brand => {
  let hostWithoutPort: string = host.split(":")[0] ?? "";

  const hostParts: string[] = hostWithoutPort.split(".");

  if (hostParts.length > 2) {
    // Consider that UK tld [co.uk] has an extra dot
    const sliceIndex: number = host.indexOf(Domains.UK) !== -1 ? -3 : -2;

    // Getting last [hostname.tld] parts, so it works for prefixed domains
    return hostParts.slice(sliceIndex)[0] as Brand;
  } else {
    return hostParts[0] as Brand;
  }
};

export default getBrandName;
